import { openReportState } from 'app/area/favourite/constants';
import { SpinLoader } from 'app/components';
import * as React from 'react';
import { useEffect } from 'react';
import { useActionCreators } from 'app/area/favourite/hooks';

interface SavedReportRouteProps {
  params: { validFavouriteId: string; companyReportId: number; modifier1?: string; modifier2?: string };
}

export function SavedReportRoute({
  params
}: SavedReportRouteProps) {
  
  const favouriteId = params?.validFavouriteId && parseInt(params.validFavouriteId, 10);
  const editSavedFavourite = params.modifier1  === openReportState.edit || params.modifier2 === openReportState.edit;
  const companyReportId = params.companyReportId;

  const {
    createCompanyReportDraftDefinition
  } = useActionCreators();
  
  useEffect(() => {
    const createDraft = () => {
      createCompanyReportDraftDefinition(favouriteId, companyReportId, editSavedFavourite);
    };
    createDraft();
  }, []);

  return <SpinLoader />;
}
